import React, { useEffect, useMemo, useState } from 'react';
import bem from 'utils/bem';
import SelectField from 'forms/fields/SelectField';
import Model from '../../../../model';
import { observer } from 'mobx-react-lite';

const { block } = bem('city-field');

const initial = { value: 'all', label: 'Все города' };
const CityField = ({ citiesOptions, setCity, city, workingOffline }) => {
    const [ options, setOptions ] = useState([ initial ]);
    const [ disabled, setDisabled ] = useState(false);
    const [ value, setValue ] = useState(initial.value);

    const onChange = (e) => {
        const value = e.target.value;
        setCity(value === initial.value ? null : value);
    }

    useEffect(() => {
        if (city) {
            setValue(city);
        } else {
            setValue(initial.value);
        }
    }, [city])

    useEffect(() => {
        if (citiesOptions.size > 0) {
            const rest = Array.from(citiesOptions).map(([id, city]) => ({
                value: id,
                label: city
            })).sort(({label: label1}, {label: label2}) => label1.localeCompare(label2));
            if (workingOffline && rest.length === 1) {
                setCity(rest[0].value);
            }
            setDisabled(!workingOffline || rest.length === 1);
            setOptions([
                initial,
                ...rest
            ]);
        }
    }, [citiesOptions, workingOffline]);

    return (
        <SelectField className={block()} name='cities' options={ options } value={ value } disabled={disabled}
                     onChange={ onChange }/>
    )
}

export default observer(CityField);
